import CURRENCIES from 'lib/Currencies.js';

export default class MoneyFormatter {
  constructor(cents = 0, currency = CURRENCIES.USD) {
    this.cents = cents;
    this.currency = currency;
  }

  /* Return this appropriate number formatter
   * @param minimumFractionDigits integer
   */
  getNumberFormatter(options = {}) {
    let locale = null;

    switch (this.currency) {
      case CURRENCIES.USD:
      default:
        locale = 'en-US';
    }

    return new window.Intl.NumberFormat(locale, options);
  }

  format(number) {
    if (number % 1) {
      return this.getNumberFormatter({ minimumFractionDigits: 2 }).format(number);
    }

    return this.getNumberFormatter().format(number);
  }

  getPrefix() {
    switch (this.currency) {
      case CURRENCIES.USD:
        return '$';
      default:
        return null;
    }
  }

  // Return the whole part of the amount (12.50 -> 12)
  getWhole() {
    return this.format(Math.floor(this._getNumericAmount()));
  }

  // Return the cent part of the amount (12.50 -> 50)
  // always prepend 0 when between 1 and 9 (12.05 -> 05)
  getCents() {
    let cents = this.cents % 100;

    if (cents === 0) {
      return null;
    }

    if (cents > 0 && cents < 10) {
      cents = '0' + cents;
    }

    return cents.toString();
  }

  getSeparator() {
    switch (this.currency) {
      default:
        return '.';
    }
  }

  // Returns the amount without formatting (1250 -> 12.50,
  // rather than 1250 -> '12.50')
  _getNumericAmount() {
    return this.cents / 100;
  }

  // Return the amount (1250 -> '12.50')
  getAmount() {
    return this.format(this._getNumericAmount());
  }

  getSuffix() {
    switch (this.currency) {
      case CURRENCIES.EUR:
        return '€';
      default:
        return null;
    }
  }

  toString() {
    return (
      (this.getPrefix() || '') +
      String(this.getAmount()) +
      (this.getSuffix() || '')
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/MoneyFormatter.js